import React from "react";
import Title from "../home/Title";
import ResumeCard from "../resume/ResumeCard";

const ProfessionalExperience = () => {
  return (
    <section id="resume">
      <Title title="My" subTitle="Professional Experience" />
      <div className="w-full grid grid-cols-3 px-8">
        <div className="col-span-9 md:col-span-4">
          <ResumeCard
            duration="Jan 2024-Present"
            title="Founder & CEO"
            subTitle="ZakCodeX | Wolverhampton, United Kingdom"
            link="https://zakcodex.com/"
            des="Lead a UK-based software and digital transformation company, delivering custom applications, AI automation, cloud solutions, and scalable platforms that drive measurable growth for international clients."
          />
          <ResumeCard
            duration="May 2025-Mar 2026"
            title="Software Engineer"
            subTitle="CodeBit AI | United States (Remote)"
            link="http://codebit.com.br/"
            des="Designed and developed serverless applications using AWS Lambda, Python, and Next.js with CI/CD pipelines, collaborating with data scientists to integrate ML models into production."
          />
          <ResumeCard
            duration="Jun 2024-Oct 2025"
            title="Software Engineer"
            subTitle="H&S Real Estate | Karachi, Pakistan (On-site)"
            link="https://hsproperty.ae/"
            des="Developed, maintained, and optimized company websites enhancing performance, SEO, and user experience while managing deployment and DNS configuration."
          />
          <ResumeCard
            duration="Jun 2024-Oct 2025"
            title="Software Engineer"
            subTitle="Deca Properties | Karachi, Pakistan (On-site)"
            link="https://deca-properties.com/"
            des="Developed and maintained responsive, SEO-optimized websites using React.js and Next.js, managing deployment pipelines and collaborating with design teams."
          />
          <ResumeCard
            duration="May 2024-May 2025"
            title="Frontend Engineer"
            subTitle="Rehani Soko | United States (Remote, Freelance)"
            link="https://rehanisoko.com/"
            des="Built and optimized dynamic front-end interfaces using Vue.js and React.js with reusable components, ensuring cross-browser compatibility and mobile responsiveness."
          />
          <ResumeCard
            duration="Dec 2023-Jun 2024"
            title="Full Stack Developer"
            subTitle="F5-STUDIO | New York, United States (Remote)"
            link="https://www.f5.studio/"
            des="Developed and deployed full-stack applications using React.js, Next.js, and Node.js with Tailwind CSS, integrating APIs for seamless data flow."
          />
          <ResumeCard
            duration="Aug 2022-Dec 2023"
            title="Software Engineer"
            subTitle="ADDITECH-SIM | Stuttgart, Germany (Remote, Part-time)"
            link="http://additechsim.ddns.net/"
            des="Designed full-stack applications using Python and JavaScript while building ML models and implementing data pipelines for real-time insights."
          />
          <ResumeCard
            duration="Jan 2022-Jun 2022"
            title="Data Science Intern"
            subTitle="ADDITECH-SIM | Stuttgart, Germany (Remote)"
            link="http://additechsim.ddns.net/"
            des="Enhanced Automatic Machine Learning Model Classifier and implemented Reinforcement Learning with Particle Swarm Optimization for optimization projects."
          />
        </div>
      </div>
    </section>
  );
};

export default ProfessionalExperience;
